/**
 * What the customer bought, subscribed to or submitted: a checkout's product title, an event's or
 * form's title. Records show this; page lists and pickers show the seller's internal name.
 */
export const getPageTitle = page => {
  if (!page) return '';
  const customerTitle =
    page.type === 'checkout' || (!page.type && page.productTitle) ? page.productTitle : page.title;
  return customerTitle || page.title || page.productTitle || page.name || '';
};
